import { render, staticRenderFns } from "./SystemNotificationsForm.vue?vue&type=template&id=084856b1&"
import script from "./SystemNotificationsForm.vue?vue&type=script&lang=js&"
export * from "./SystemNotificationsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports